import React from "react";

export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    /**
     * Allow to toggle between two options
     *
     * @param {object} props
     * @param {int} props.default
     * @param {string} props.property
     * @param {string} props.label
     * @param {grapesjs.Component} props.component
     * @param {function} [props.onToggleRight]  call back triggered when toggled on
     * @param {function} [props.onToggleLeft] call back triggered when toggled off
     * @param {string} props.type
     */
    styleManager.addType(window.PMW.emails.styles.ID_TOGGLE_SWITCH, {
        create({props, change}) {

            const currComponent = editor.runCommand(window.PMW.emails.commands.GET_COMPONENT_FOR_TOGGLE_SWITCH, {component: props.component}),
                toggleSelector = document.createElement('div'),
                attributes = currComponent.getAttributes() || {};

            let isToggled = false;
            if ((props.attribute && attributes[props.attribute]) || props.default) {
                isToggled = true;
            }

            toggleSelector.className = props.type;
            toggleSelector.innerHTML = getToggleSwitchHtml(props, isToggled);
            const tooltip = toggleSelector.getElementsByClassName('react-tooltip')[0];
            attachListenerPresetToggleButtonSelector(props, change, toggleSelector);

            if (props.callback) {
                props.callback(tooltip)
            }

            return toggleSelector;
        },

        emit({props}, {toggleButton}) {
        }
    });

    /**
     *
     * @param props
     * @param change
     * @param toggleContainer
     */
    function attachListenerPresetToggleButtonSelector(props, change, toggleContainer) {
        toggleContainer.querySelector('.tgl').addEventListener('change', function (toggleButton) {
            if (toggleButton.target.checked) {
                props.onToggleRight();
            } else {
                props.onToggleLeft();
            }
        });
    }

    /**
     * @param {object} props
     * @param isToggled
     * @return {string} containing markup for toggle switch
     */
    function getToggleSwitchHtml(props, isToggled = false) {
        return `
            <div class="toggle-container spacing-m-0">
                <div class="flexbox flex-justify-between flex-align-items-center">
                    <label class="toggle-text body-xs">${props.label}</label>
                    <div class="react-tooltip spacing-m-l-2"></div>
                </div>
                <div class="toggle">
                    <input id="js-column-section-responsive-chk" class="tgl" type="checkbox"  aria-label="${i18next.t('pmwjs_stack_layout')}"  ${isToggled ? 'checked' : ''}/>
                    <label for="js-column-section-responsive-chk" class="tgl-btn" aria-label="${i18next.t('pmwjs_stack_layout')}"></label>
                </div>
            </div>
        `
    }

    /**
     * @param {grapesjs.Component} component
     * @returns {grapesjs.Component}
     */
    function getComponentForIdToggleSwitch(component) {
        component = component || editor.getSelected()
        if (component.parent().get('tagName').toLowerCase() === 'a') {
            return component.parent();
        }
        return component;
    }
};